import store from "@/core/services/store";
import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
import {
  UPDATE_PERSONAL_INFO,
  UPDATE_USER_DATA
} from "@/core/services/store/profile.module";
import { bus } from "@/main";
import { getAuth0 } from "@/plugins/auth0-plugin";
import BaseAuth from "@/components/General/Auth/baseAuth";

let auth0;

class Auth0 {
  constructor() {
    if (auth0 || !BaseAuth.useAuth0()) return;

    auth0 = getAuth0();
  }

  async login() {
    // Remove the old token from the legacy login
    JwtService.destroyToken();
    ApiService.removeHeaderByKey("Authorization");
    await auth0.loginWithRedirect();
  }

  async logout() {
    await auth0.logout();
    BaseAuth.handleLogout();
    JwtService.destroyToken();
  }

  async getToken() {
    return auth0.getAccessTokenSilently();
  }

  async getUser() {
    return auth0.user || auth0.getUser();
  }

  getClaims() {
    return auth0.getIdTokenClaims();
  }

  isLoading() {
    return auth0.isLoading;
  }

  isAuthenticated() {
    return auth0.isAuthenticated;
  }

  updateUserData(userData) {
    if (typeof userData === "undefined") {
      return;
    }

    const user = {
      ...userData,
      usesAuth0: true
    };

    store.dispatch(UPDATE_USER_DATA, user);
    store.dispatch(UPDATE_PERSONAL_INFO, user);
    bus.$emit("loggedIn", user);
  }
}

export default new Auth0();
